<template>
  <div class="upload-layout">
    <ul :class="{ hasImg: hasImg }">
      <template v-if="hasImg">
        <li v-for="item in imgList" v-if="item.data" class="img-list">
          <div v-if="item.data.res && item.data.res.content">
            <img :src="item.data.res.content.downloadUrl" alt="" />
            <i @click="deleteCurrent(item)"></i>
          </div>
        </li>
      </template>
      <li v-show="selectImgNums > 0">
        <div class="btn-upload">
          <kfcv-upload
            accept="image/*"
            :rest="selectImgNums"
            @uploadResponse="uploadResponse"
          />
          <i></i>
          <p>{{ hasImg ? '添加图片' : '添加图片，有机会成为精选评价哦' }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import upload from '@/components/common/kf-upload/index.vue'
export default {
  components: {
    [upload.name]: upload
  },
  props: {
    initImgList: {
      type: [Array],
      default() {
        return []
      }
    }
  },
  data() {
    return {
      imgList: []
    }
  },
  watch: {
    initImgList(value, oldValue) {
      if (value.length > 0 && value.length != oldValue.length) {
        this.imgList = value.map((item, index) => {
          return {
            code: 4,
            data: {
              id: index,
              res: {
                content: {
                  downloadUrl: item
                }
              }
            }
          }
        })
      }
    }
  },
  computed: {
    hasImg() {
      return this.imgList && this.imgList.length > 0
    },
    selectImgNums() {
      //可选择的图片数量
      return 9 - this.imgList.length
    }
  },
  methods: {
    uploadResponse(res) {
      // const index = this.imgList.findIndex(item => item.data.id === res.data.id)
      // if(index > -1) {
      //     this.imgList[index] = res
      // } else {
      //     this.imgList.push(res)
      // }
      // if(res.code > 4 && index > -1) {
      //     this.imgList.splice(index,1);
      // }
      if (res.code == 4) {
        this.imgList.push(res)
      }
      this.$emit('onChangeImgList', this.imgList)
      this.$forceUpdate()
    },
    deleteCurrent(res) {
      // 删除当前图片
      const index = this.imgList.findIndex(item => item.data.id === res.data.id)
      if (index > -1) {
        this.imgList.splice(index, 1)
        this.$emit('onChangeImgList', this.imgList)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.upload-layout {
  padding: 0 rem(24px);
  padding-bottom: rem(30px);
  display: flex;
  border-radius: rem(16px);
  ul {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    li {
      width: 100%;
      &.img-list > div {
        width: rem(210px);
        height: rem(210px);
        position: relative;

        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
        p {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          top: 0;
          height: 100%;
          line-height: rem(210px);
          background-color: rgba(0, 0, 0, 0.6);
          color: #fff;
          text-align: center;
        }
        i {
          position: absolute;
          top: 0;
          right: 0;
          width: rem(40px);
          height: rem(40px);
          background: url('~@/assets/images/evaluate/icon-delete@3x.png')
            no-repeat;
          background-position: left bottom;
          background-size: rem(32px) auto;
        }
      }
    }
    &.hasImg {
      margin: 0 rem(-6px);
      width: auto;
      li {
        width: auto;
        padding: rem(6px);
        > div {
          border-radius: rem(8px);
          width: rem(210px);
        }
      }
    }
  }
  .btn-upload {
    position: relative;
    border-radius: rem(16px);
    width: 100%;
    height: rem(210px);
    text-align: center;
    padding: rem(48px) 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fafafa;

    > i {
      display: block;
      width: rem(72px);
      height: rem(72px);
      background: url('~@/assets/images/evaluate/cam@3x.png') no-repeat center;
      background-size: 100% auto;
    }
    > p {
      font-size: rem(24px);
      color: #999999;
      line-height: rem(30px);
      padding-top: rem(12px);
    }
    &.hasImg {
      width: rem(210px);
    }
  }
}
</style>
